import { firebaseApp } from './Firebase'
import 'firebase/compat/remote-config'

export enum ConfigValue {
  appConfigHost = 'app_config_host',
  deepLinkDomain = 'deep_link_domain',
  deepLinkItem = 'deep_link_item',
  shareAndroidPackage = 'share_android_package',
  shareIOSId = 'share_ios_id',
  shareIOSPackage = 'share_ios_package',
  shopifyApiBaseUrl = 'shopify_api_base_url',
  shopifyApiToken = 'shopify_api_token',
  defaultDynamicLink = 'default_dynamic_link'
}

export const utmAppname = 'warmwishes' // Google Campaign source
export const dynamicLinksService = 'https://dynamic-links.live.warm-wishes.app'
export const remoteConfig = firebaseApp.remoteConfig()
remoteConfig.settings.minimumFetchIntervalMillis = 30000 // 3600000

remoteConfig.defaultConfig = {
  app_config_host: 'https://live.warm-wishes.app',
  deep_link_domain: 'https://foryou.warm-wishes.app',

  // The following values don't exist in firebase anymore
  deep_link_item: 'https://warm-wishes.app/detail/{itemId}',
  share_android_package: 'app.warmwishes',
  // share_ios_id: '1097028383',
  // share_ios_package: 'app.warmwishes',
  shopify_api_base_url: 'https://spruche-app-de.myshopify.com',
  // shopify_api_token: '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',
  default_dynamic_link: 'https://foryou.warm-wishes.app'
}

remoteConfig.fetchAndActivate()
